import { Badge } from '@entur/layout'
import React from 'react'
import { TicketRight } from '../../api-clients/api-types'

type RuleElementProps = {
  categoryName?: string
  ticketRight?: TicketRight
}
export const TicketRightCategoryBadge: React.FC<RuleElementProps> = (props) => {
  const categoryName =
    props.categoryName ||
    props.ticketRight?.ticketType?.description?.split(' ')[3]?.trim() ||
    props.ticketRight?.ticketType?.description?.split(' ')[1]?.trim()

  return props.ticketRight ? (
    <Badge style={{ display: 'inline-block', whiteSpace: 'nowrap' }} variant="neutral">
      {`${props.ticketRight?.ticketType?.code} - ${categoryName}`}
    </Badge>
  ) : (
    <></>
  )
}
